/**
 * 七陌在线客服
 */

// 唤醒七陌在线客服（7moorInit.js 为 async 加载，autoShow=false 时需调用全局 qimoChatClick 打开会话窗口）
export function openCustomerService() {
  if (typeof window.qimoChatClick === "function") {
    window.qimoChatClick();
    return;
  }
  // 脚本尚未就绪时轮询等待，最多约 6 秒
  let retry = 0;
  const timer = setInterval(() => {
    retry += 1;
    if (typeof window.qimoChatClick === "function") {
      clearInterval(timer);
      window.qimoChatClick();
    } else if (retry >= 20) {
      clearInterval(timer);
    }
  }, 300);
}
